import { render } from "./addTeapplix.vue?vue&type=template&id=5030e5d7&scoped=true"
import script from "./addTeapplix.vue?vue&type=script&lang=js"
export * from "./addTeapplix.vue?vue&type=script&lang=js"

import "./addTeapplix.vue?vue&type=style&index=0&id=5030e5d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5030e5d7"]])

export default __exports__